import { BookOpen, Terminal, Network, Shield, Award, Users, MessageCircle } from "lucide-react";
import { AnimatedText } from "../components/shared/AnimatedText";
import { AnimatedBlock } from "../components/shared/AnimatedBlock";

const ICONS = [BookOpen, Terminal, Network, Shield, Award, Users];

export function FreeSection({ t }) {
  return (
    <section id="free" className="bg-blue-900" style={{ minHeight: "100vh", display: "flex", alignItems: "center" }}>
      <div className="container mx-auto px-4 py-14">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <AnimatedText text={t.free.title} tag="h2" className="text-4xl md:text-5xl font-black text-white mb-4" />
            <AnimatedText text={t.free.subtitle} tag="p" delay={80} className="text-blue-200 text-base max-w-3xl mx-auto leading-relaxed" />
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
            {t.free.items.map((item, idx) => {
              const IconComp = ICONS[idx];
              return (
                <AnimatedBlock key={item.title} delay={idx * 70} className="bg-white/10 backdrop-blur rounded-2xl p-5 border border-white/20 hover:bg-white/15 transition-all duration-300 hover:-translate-y-1">
                  <div className="flex items-start gap-4">
                    <div className="w-11 h-11 rounded-xl bg-[#F08232] flex items-center justify-center flex-shrink-0">
                      <IconComp className="w-5 h-5 text-white" />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-white font-bold text-base mb-2">{item.title}</h3>
                      <p className="text-blue-200 text-sm leading-relaxed mb-3">{item.desc}</p>
                      <span className="inline-block bg-[#F08232]/20 text-[#F08232] text-xs font-semibold px-3 py-1 rounded-full border border-[#F08232]/30">{item.tag}</span>
                    </div>
                  </div>
                </AnimatedBlock>
              );
            })}
          </div>
          <AnimatedBlock delay={200} className="mt-10 text-center">
            <p className="text-blue-200 mb-6 text-base">{t.free.spotsNote}</p>
            <a href="https://whatsapp.com/channel/0029Vav7qNSJENy7Vywa2M3R" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-[#F08232] hover:bg-orange-400 text-white px-10 py-4 rounded-full font-semibold text-lg transition-all hover:scale-105 shadow-lg">
              <MessageCircle className="mr-2 w-5 h-5" />{t.free.cta}
            </a>
          </AnimatedBlock>
        </div>
      </div>
    </section>
  );
}
